import React, { useState, useEffect } from "react";
import {
  getActiveModule,
  getSIngleActiveModule,
} from "../../services/ActivePrograms";
import Loader from "../../commonComponent/Loader";
import { useParams } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";
import ButtonWithIcon from "../../commonComponent/ButtonWithIcon";
import { RiEdit2Fill } from "react-icons/ri";
import { IoChevronBackOutline, IoChevronForwardOutline } from "react-icons/io5";
import { BsFillFileEarmarkPdfFill } from "react-icons/bs";
import { FiDownload } from "react-icons/fi";
const ActiveModuleInfo = (props) => {
  const [module, setModule] = useState(null);
  const [isLoading, setLoader] = useState(true);
  useEffect(() => {
    getSIngleModuleById(props.module._id);
    // eslint-disable-next-line
  }, [props.module._id]);

  const getSIngleModuleById = async (ModuleId) => {
    setLoader(true);
    try {
      if (!ModuleId) {
        return;
      }
      const response = await getSIngleActiveModule(props.programId, ModuleId);
      if (response.status === 200 && response.data) {
        const module = response.data.data[0];
        console.log(module, "module");
        setModule(module);
      } else {
        console.log(response?.data || response.message);
      }
      setLoader(false);
    } catch (error) {
      error?.data?.data &&
        console.log(error?.data?.data || error.data?.message);
      setLoader(false);
    }
  };

  return (
    <>
      {isLoading ? (
        <center>
          <div
            style={{ width: "3rem", height: "3rem", color: "#1f7e78" }}
            class="spinner-border mt-3 mb-4"
            role="status"
          />
        </center>
      ) :  (
        <div className="containers">
          <div className="my-2">
            <button
              className="btn btn-primary btn-custom-tag "
              onClick={props.handleAllModule}
            >
              <IoArrowBack /> &nbsp;&nbsp;&nbsp; All Modules
            </button>
          </div>
          <div className="my-4 row align-items-center">
            <div className="col-md-6">
              <h2 className="chidHeadFont">
                <span className="h4" style={{ color: "#1f7e78" }}>
                  {props.currentIndex + 1 < 10 && "0"}{props.currentIndex + 1}   &nbsp; &nbsp; &nbsp;
                </span>
                {module?.title}
              </h2>
            </div>
            <div className="col-md-6 d-flex justify-content-between align-items-center">
              <ButtonWithIcon
                className={`btn btn-light px-4 py-2 ${!props.hasPreviousModule ? 'disabled' : ''}`}
                onClick={() => props.hasPreviousModule && props.handlePreviousModule(module)}
                label="Previous Module"
                icon={<IoChevronBackOutline />}
              />

              <ButtonWithIcon
                className={`btn btn-light px-4 py-2 ${!props.hasNextModule ? 'disabled' : ''}`}
                onClick={() => props.hasNextModule && props.handleNextModule(module)}
                label="Next Module" 
                iconPosition="right"
                icon={<IoChevronForwardOutline />}
              />
              <div className="">
                <button className="btn btn-primary btn-custom" onClick={() => props.handleEditModule(module)}>
                  <RiEdit2Fill />
                  &nbsp;&nbsp; Edit
                </button>
              </div>
            </div>
            {/* <p className="resFont">Gravida vestibulum felis tristique lectus elementum. Amet ut est cursus sociis.</p> */}
          </div>
          <div className="mt-4">
            <div className="d-flex">
              <div className="me-5">
                <img
                  src={module?.image}
                  alt=""
                  className="module-info-thumbnail"
                />
              </div>
              <div>
                <h6 className="text-muted">Module Description</h6>
                <p>{module?.description}</p>
              </div>
            </div>
          </div>
          <div className="mt-4">
            <div
              className="mt-4"
              dangerouslySetInnerHTML={{ __html: module?.content }}
            />
          </div>
          {module?.attachments?.length > 0 && (
          <div className="mt-4">
            <h5>Files</h5>
            <div className="d-flex w-100 overflow-x-auto">
                {module?.attachments?.map((attachment) => (
                    <div className="me-3 d-flex align-items-center gap-2 bg-light p-3 rounded">
                      <div className="rounded bg-white p-3">
                        <BsFillFileEarmarkPdfFill className="text-danger fs-1" />
                      </div>
                      <div style={{maxWidth: "20rem"}} >
                        <h6 className="mb-0 module-info-files-title">{attachment?.split("/").pop()}</h6>
                        <span  className="text-muted text-uppercase mb-0">{attachment?.split(".").pop()}</span><br />
                        <a href={attachment} target="_blank" rel="noreferrer">  
                          <FiDownload style={{color: "#156563",fontSize: "1.5rem" }} />
                        </a>
                      </div>
                    </div>
                ))}
            </div>
          </div>
          )}
        </div>
      )}
    </>
  );
};

export default ActiveModuleInfo;
